import { useQuery } from "react-query";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { usePunditUserContext } from "@circle-react/contexts";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import type { CurrentPlan } from "@circle-react/types";

const PLAN_CACHE_TIME = 1000 * 60 * 60;
const PLAN_STALE_TIME = 1000 * 60 * 10;

export const useBillingDetailsApi = () => {
  const { currentCommunityMember } = usePunditUserContext();
  const isAdmin = Boolean(currentCommunityMember?.is_admin);

  const {
    data: currentPlan,
    isLoading: isCurrentPlanLoading,
    error: errorFetchingCurrentPlan,
    refetch: refetchCurrentPlan,
    isRefetching: isRefetchingCurrentPlan,
  } = useQuery<CurrentPlan>({
    queryKey: ["community-billing-details"],
    queryFn: () =>
      reactQueryGet(
        internalApi.communities.billing.communitySubscription.show(),
      ),
    retry: 2,
    enabled: isAdmin,
    cacheTime: PLAN_CACHE_TIME,
    staleTime: PLAN_STALE_TIME,
  });

  return {
    currentPlan,
    isCurrentPlanLoading,
    errorFetchingCurrentPlan,
    refetchCurrentPlan,
    isRefetchingCurrentPlan,
  };
};
